import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class Footer extends Component{
  render() {
    return(
      <footer className="container">
        <div>
          <p className="Footer-title">Kontakt</p>
          <p className="d-flex">
            Mejl
            <a href="mailto:info@escapat.com">info@escapat.com</a>
          </p>
          <p className="d-flex">
            Telefon
            <a href="tel:+496170961709">070-769 97 61</a>
          </p>
        </div>
        <div>
          <p className="Footer-title">Länkar</p>
          <p>
            <Link to="/">Abonnemang</Link>
          </p>
          <p>
            <Link to="/info">Info</Link>
          </p>
          <p>
            <a href="https://www.escapat.com/" target="_blank"
              rel="noopener noreferrer">
              Webshop
            </a>
          </p>
        </div>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer.jsx